//Componentes Generales
import React, { useContext, useEffect } from "react";
import productsContext from "../../context/productos/productsContext";
import agregarReqContext from "../../context/agregarReq/agregarReqContext";
import authContext from "../../context/authentication/authContex";
import FormReq from "../../components/FormReq/FormReq";

// Alertas
import Swal from "sweetalert2";

//Estilos
import "./AddReq.css";

/* 
    Vista donde se gestiona toda la lógica para añadir un comprobante.
        Donde reqEdit no esta en uso.
              cerrar no esta en uso.
*/
function AddReq({ reqEdit, cerrar }) {
  //Context de Autenticacion
  const aContext = useContext(authContext);
  const { usuario: user } = aContext;

  //Context productos
  const pContext = useContext(productsContext);
  const { products, actualizarProducts } = pContext;

  //Context agregar comprobante
  const addContext = useContext(agregarReqContext);
  const { req, guardarComprobante, itemsList } = addContext;

  /* 
        Disparador que actualiza la lista de productos disponibles al momento de renderizar el componente.
    */
  useEffect(() => {
    const fn = async () => {
      await actualizarProducts();
    };
    fn();
  }, []);


  const handleSaveReq = async (requeriment, items, files, conceptos = [], aditionalDocs) => {
    if (requeriment !== undefined && requeriment !== null) {
        const resp = await guardarComprobante(
          requeriment,
          items,
          user,
          files,
          conceptos,
          aditionalDocs
        );
        Swal.fire({
          title: `Se guardó una nueva ${resp.tDocCodForDescrp}`,
          icon: "success",
          text: `El número de la ${resp.tDocCodForDescrp} es : ${resp.tDocNroFor}`,
          showConfirmButton: true,
          allowEnterKey: true,
        });
        return true;
    } else {
      return false;
    }
  };

  return (
    <div>
      <FormReq
        req={reqEdit ? reqEdit : req}
        itemList={itemsList}
        productList={products}
        guardarReq={handleSaveReq}
        cerrar={cerrar}
      />
    </div>
  );
}

export default AddReq;